import { Component, Inject, OnInit } from '@angular/core';
import { TableColumnService } from '../services/table-column.service';
import { TableColumn } from '../../../models/table-column';
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDropListGroup, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-column-selector',
    templateUrl: './column-selector.component.html',
    styleUrls: ['./column-selector.component.scss'],
    imports: [CdkDropListGroup, CdkDropList, CdkDrag, NgClass, MatButton]
})
export class ColumnSelectorComponent implements OnInit {

    public columns: TableColumn[];
    public initialColumns: string[];
    public selectedColumns: string[];
    public availableColumns: string[];
    public captions = {};

    constructor(@Inject(MAT_DIALOG_DATA) data: { entity: string, selection: string[] },
                private dialogRef: MatDialogRef<ColumnSelectorComponent>,
                private tableColumnService: TableColumnService) {
        this.columns = this.tableColumnService.getColumnsForEntity(data.entity);
        this.columns.forEach(c => {
            this.captions[c.id] = c.caption;
        });
        this.selectedColumns = [ ...data.selection ];
        this.initialColumns = [ ...data.selection ];
        this.availableColumns = this.columns
            .filter(c => this.selectedColumns.indexOf(c.id) === -1)
            .map(c => c.id);
    }

    ngOnInit(): void {
    }

    dropSelected(event: CdkDragDrop<string[]>): void {
        console.log(event);
        const selected = [ ...this.selectedColumns ];
        const available = [ ...this.availableColumns ];
        if (event.previousContainer === event.container) {
            moveItemInArray(selected, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(available, selected, event.previousIndex, event.currentIndex);
        }
        this.selectedColumns = selected;
        this.availableColumns = available;
    }

    dropAvailable(event: CdkDragDrop<string[]>): void {
        console.log(event);
        const selected = [ ...this.selectedColumns ];
        const available = [ ...this.availableColumns ];
        if (event.previousContainer === event.container) {
            moveItemInArray(available, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(selected, available, event.previousIndex, event.currentIndex);
        }
        this.selectedColumns = selected;
        this.availableColumns = available;
    }

    close(): void {
        this.dialogRef.close(null);
    }

    save(): void {
        this.dialogRef.close(this.selectedColumns);
    }

    selectColumn(id: string): void {
        this.selectedColumns = [ ...this.selectedColumns, id ];
        this.availableColumns = [ ...this.availableColumns.filter(c => c !== id) ];
    }

    unselectColumn(id: string): void {
        this.selectedColumns = [ ...this.selectedColumns.filter(c => c !== id) ];
        this.availableColumns = [ ...this.availableColumns, id ];
    }

}
